

  import { MessagePayload } from "@firebase/messaging";
  import { container } from "tsyringe";
  import { defineComponent } from 'vue';

  import { NotificationService } from "./services/NotificationService";

  export default defineComponent({

    data() {
      return {
        messagePayload: null,
        title: 'Driver',
        additionalKey: 1,
        authenticated: false
      }
    },

    methods: {
      async logout() {
        // Navigate back to home
        this.$router.push({path: '/'});
      },

      /** Open notification URL and close dialog */
      openNotificationUrl() {
        let msg = this.messagePayload;
        document.getElementById('notificationModalDismiss').click();
        // if there is caseId in the data section => redirect to transport detail => force refresh (update())
        if(msg.data && msg.data.caseId) {
          this.notificationOpenerMethod(msg.data.caseId);
        }
      },

      // method called for opening detail of the business case (transport) with offered event time
      notificationOpenerMethod(caseId: number) {
        this.$router.push({ path: '/detail/' + caseId, query: { refresh: new Date().getTime() } });
      },

      /** Close notification and perform no action */
      closeNotification() {
        document.getElementById('notificationModalDismiss').click();
      }

    },

    async mounted() {
      const notificationService = container.resolve(NotificationService);
      await notificationService.init();

      // listen for the messages received from serviceWorker (app is on background)
      navigator.serviceWorker.addEventListener('message', event => {
        if(event.data && event.data.data && event.data.data.caseId) {
          this.notificationOpenerMethod(event.data.data.caseId);
        }
      });

      // If message is received (app has focus)
      notificationService.onMessage.attach((msg: MessagePayload) => {
        this.messagePayload = msg;
        document.getElementById('notificationModalOpener').click();
      });
    }
})

